import {
  ProcurementPurchaseOrderResponse,
  ProcurementPurchaseOrderItemResponse,
  ProcurementPurchaseOrderRequest,
  ProcurementPurchaseOrderTypeResponse,
} from "lib-klab-sdks";
import {
  PurchaseOrder,
  PurchaseOrderItem,
  PurchaseOrderRequest,
  PurchaseOrderType,
} from "../../../domain/models/procurement/purchase-order.model";

export function mapPurchaseOrderType(source: ProcurementPurchaseOrderTypeResponse): PurchaseOrderType {
  return { id: source.id, code: source.code, name: source.name, description: source.description, active: source.active };
}

export function mapPurchaseOrderItem(source: ProcurementPurchaseOrderItemResponse): PurchaseOrderItem {
  return {
    id: source.id,
    purchaseOrderId: source.purchaseOrderId,
    productName: source.productName,
    unitOfMeasure: source.unitOfMeasure,
    quantity: source.quantity,
    unitPrice: source.unitPrice,
    subtotal: source.subtotal,
    igvAmount: source.igvAmount,
    totalPrice: source.totalPrice,
    currencyId: source.currencyId,
    itemOrder: source.itemOrder,
  };
}

export function mapPurchaseOrder(source: ProcurementPurchaseOrderResponse): PurchaseOrder {
  return {
    id: source.id,
    orderNumber: source.orderNumber,
    orderTypeId: source.orderTypeId,
    orderType: source.orderType,
    companyId: source.companyId,
    company: source.company,
    supplierId: source.supplierId,
    supplier: source.supplier,
    statusId: source.statusId,
    status: source.status,
    currencyId: source.currencyId,
    subtotal: source.subtotal,
    igvAmount: source.igvAmount,
    totalAmount: source.totalAmount,
    issueDate: source.issueDate,
    createdAt: source.createdAt,
    updatedAt: source.updatedAt,
    observations: source.observations,
    contactPerson: source.contactPerson,
    contactEmail: source.contactEmail,
    contactPhone: source.contactPhone,
    deliveryAddress: source.deliveryAddress,
    receivingPerson: source.receivingPerson,
    shippingMethod: source.shippingMethod,
    requestingArea: source.requestingArea,
    shippingConditions: source.shippingConditions,
    serviceStartDate: source.serviceStartDate,
    serviceEndDate: source.serviceEndDate,
    serviceModality: source.serviceModality,
    items: source.items.map(mapPurchaseOrderItem),
  };
}

export function mapPurchaseOrderRequest(request: PurchaseOrderRequest): ProcurementPurchaseOrderRequest {
  return {
    ...request,
    items: request.items.map((item) => ({
      productName: item.productName,
      unitOfMeasure: item.unitOfMeasure,
      quantity: item.quantity,
      unitPrice: item.unitPrice,
      subtotal: item.subtotal,
      igvAmount: item.igvAmount,
      totalPrice: item.totalPrice,
      currencyId: item.currencyId,
      itemOrder: item.itemOrder,
    })),
  };
}
